import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { DashboardFournisseurState, state } from '@/modules/DashboardFournisseur/store/state';
import { mutations } from '@/modules/DashboardFournisseur/store/mutations';
import { actions } from '@/modules/DashboardFournisseur/store/actions';
import { getters } from '@/modules/DashboardFournisseur/store/getters';

const module: Module<DashboardFournisseurState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { DashboardFournisseurState };

